<script lang="ts">
  import { Building2 } from 'lucide-svelte';
  import { siteCode } from '$lib/utils/format';
  import type { Ticket } from '$lib/types';

  // redact=true (or the ticket simply lacking src_company/src_property,
  // which is what a non-admin's JSON looks like after server-side
  // redaction — see genba-api-spec.md's "HARD RULE (isolation)") shows only
  // the site code + room; company/property never render for members.
  const { ticket, redact = false }: { ticket: Ticket; redact?: boolean } = $props();
  const hideCompany = $derived(redact || ticket.src_company === undefined);
  const code = $derived(siteCode(ticket.src_site, ticket.src_company, ticket.src_property));
</script>

<div class="src-badge">
  <span class="crm"><Building2 size={14} />From CRM</span>
  <span class="sep">·</span>
  {#if hideCompany}
    <b>{code}</b>
    <span class="sep">·</span>
    <b>{ticket.src_room}</b>
  {:else}
    <b style="font-family:var(--mono)">{code}</b>
    <span class="sep">·</span>
    <b>{ticket.src_company}</b>
    <span class="sep">·</span>
    <span>{ticket.src_property}</span>
    <span class="sep">·</span>
    <b>{ticket.src_room}</b>
  {/if}
</div>
